import { coreApi } from '$api'
import { IAccount } from '$models'
import { getActiveCompanySettings, singletonQueryClient } from '$utils'

enum QueryKeys {
  getThirdPartyAccounts = 'getThirdPartyAccounts',
}

/**
 * Retrieves all third party accounts
 * @returns an list of third party accounts
 */
export const getThirdPartyAccounts = async (
  system: string
): Promise<IAccount[]> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return []

  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.getThirdPartyAccounts, { system }],
    queryFn: async () => {
      return await coreApi.getThirdPartyAccounts(system)
    },
  })
}

export const setDefaultFreightAccount = async (
  thirdPartyFreightAccount: string | undefined,
  system: string
): Promise<boolean> => {
  try {
    await coreApi.setDefaultFreightAccount(thirdPartyFreightAccount, system)
    return true
  } catch (error) {
    return false
  }
}
